import EsfirusButtonNative from "@components/ui/Button/EsfirusButtonNative";
import EsfirusSelect from "@components/ui/Select/EsfirusSelect";
import EsfirusTextInput from "@components/ui/Text-input/EsfirusTextInput";
import { Modal } from "@mui/material";
import { FichajeFormData, TimeKeepingTypeERP } from "@screens/TrackHoras/types";
import { configurationService } from "@services/configApp";
import { fichajesService } from "@services/fichajes";
import { useEffect, useState } from "react";
import "./ModalFichajeData.scss";

interface ModalFichajeDataProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onSave: (data: FichajeFormData) => Promise<void>;
}

const ModalFichajeData = ({ open, setOpen, onSave }: ModalFichajeDataProps) => {
  const { showTimeKeepingTypeInput, showTimeKeepingDescriptionInput, timeKeepingTypeDefault } = configurationService.getConfigFichaje();
  const [fichajesTypes, setFichajesTypes] = useState<TimeKeepingTypeERP[]>([])
  const [loadingFichajesType, setLoadingFichajesType] = useState<boolean>(false)
  const [form, setForm] = useState<FichajeFormData>({
    type: timeKeepingTypeDefault || "",
    description: "",
  });

  const loadFichajesTypes = async () => {
    setLoadingFichajesType(true)

    try {
      const response = await fichajesService.getTypes()
      const types: TimeKeepingTypeERP[] = response?.data?.data ?? []
      setFichajesTypes(types)
    } catch (error) {
      setFichajesTypes([])
    } finally {
      setLoadingFichajesType(false)
    }
  }

  useEffect(() => {
    loadFichajesTypes()
  }, [])

  // Render
  const typeOptions = fichajesTypes.map(ft => ({ label: ft.description, value: ft.timekeeping_type }))
  const buttonDisabled = showTimeKeepingTypeInput && !form.type;

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="modal-fichaje-data">
        <div className="header">
          <h5 className="text-center">Datos del fichaje</h5>
        </div>
        <div className="body">
          <form className="form-container">
            {showTimeKeepingTypeInput && (
              <div>
                <label>Tipo de fichaje</label>
                <EsfirusSelect
                  options={typeOptions}
                  change={(e: any) => setForm({ ...form, type: e })}
                  value={form.type}
                  placeholder="Seleccionar..."
                  disabled={loadingFichajesType}
                />
              </div>
            )}
            {showTimeKeepingDescriptionInput && (
              <div>
                <label>Descripción</label>
                <EsfirusTextInput
                  fullWidth
                  value={form.description}
                  onChange={(e: any) => {
                    setForm({ ...form, description: e.target.value })}}
                  placeholder="Escribe una descripción"
                />
              </div>
            )}
          </form>
          <div className="button-container">
            <EsfirusButtonNative
              click={async () => {
                await onSave(form)
                setOpen(false)
              }}
              disabled={buttonDisabled}
              label="Guardar fichaje"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalFichajeData;
